import { Instagram, Mail, MessageCircle } from "lucide-react";
import { useContent, useLang } from "@/context/AppContext";

// Footer — editorial colophon.
export default function Footer() {
  const { t } = useLang();
  const { content } = useContent();
  const s = content?.settings || {};

  const socials = [
    { icon: MessageCircle, href: s.whatsapp_link || "#", label: "WhatsApp", testid: "footer-social-whatsapp" },
    { icon: Mail, href: s.email ? `mailto:${s.email}` : "#", label: "Email", testid: "footer-social-email" },
    { icon: Instagram, href: s.instagram ? `https://instagram.com/${s.instagram}` : "#", label: "Instagram", testid: "footer-social-instagram" },
  ];

  return (
    <footer className="border-t border-hairline bg-obsidian" data-testid="footer">
      <div className="mx-auto max-w-7xl px-4 py-14 sm:px-8 lg:px-16">
        <div className="flex flex-col gap-8 sm:flex-row sm:items-start sm:justify-between">
          <div>
            <div className="flex items-baseline gap-1">
              <span className="font-display text-2xl font-semibold tracking-tight text-bone">Ryan Hidayat</span>
              <span className="font-display text-2xl italic text-vermilion">.</span>
            </div>
            <p className="mt-3 font-mono text-[11px] uppercase tracking-[0.18em] text-sand">{t("footerTagline")}</p>
          </div>
          <div className="flex items-center gap-2">
            {socials.map((soc) => (
              <a
                key={soc.label}
                href={soc.href}
                target="_blank"
                rel="noopener noreferrer"
                aria-label={soc.label}
                data-testid={soc.testid}
                className="flex h-10 w-10 items-center justify-center border border-hairline text-sand transition-colors hover:border-vermilion hover:text-vermilion"
              >
                <soc.icon className="h-4 w-4" />
              </a>
            ))}
          </div>
        </div>
        <div className="mt-12 flex flex-col gap-3 border-t border-hairline pt-6 sm:flex-row sm:items-center sm:justify-between">
          <p className="font-mono text-[11px] text-sand">© {new Date().getFullYear()} Ryan Hidayat. {t("rights")}</p>
          <p className="font-mono text-[11px] text-sand">ID · UTC+7</p>
          <a href="/admin" data-testid="footer-admin-link" className="font-mono text-[11px] uppercase tracking-widest text-sand transition-colors hover:text-vermilion">
            {t("adminLink")}
          </a>
        </div>
      </div>
    </footer>
  );
}
